export const BASE_EVENT_CATEGORY = {
  NEWS: { value: 'News' },
  CRIME: { value: 'Crime/Infraction' },
  NATURAL_DISASTER: { value: 'Natural Disaster' },
  HEALTH_HAZARD: { value: 'Health hazard' }, // deprecated
  PUBLIC_HEALTH_HAZARD: { value: 'Public health hazard' },
  ACCIDENT: { value: 'Accident' }, // deprecated
  SOCIAL_POLITICAL: { value: 'Social/Political' },
  CONFLICT: { value: 'Conflict' },
  SITE_INCIDENT: { value: 'Site Incident' },
  CLEANING_TASK_INCIDENT: { value: 'Cleaning: Task Incident' },
  MAINTENANCE_TASK_INCIDENT: { value: 'Maintenance: Task Incident' },
  TASK_INCIDENT: { value: 'Task Incident' }, // deprecated
  TRAVEL_INCIDENT: { value: 'Travel Incident' },
  TRIP_INCIDENT: { value: 'Trip Incident' },
  ASSET_INCIDENT: { value: 'Asset Incident' },
  CUSTOMER_INCIDENT: { value: 'Customer Incident' },
  OCCUPATIONAL_INCIDENT: { value: 'Occupational Incident' },
  SECURITY_EMERGENCY: { value: 'Security: Emergency Incident' },
  SECURITY_ASSET: { value: 'Security: Asset Incident' },
  SECURITY_TRANSPORT: { value: 'Security: Transport Incident' }, // deprecated
  SECURITY_PATROL: { value: 'Security: Patrol Incident' },
  SECURITY_SITE: { value: 'Security: Site Incident' }, //deprecated
  OTHERS: { value: 'Others' },
  CONTINUAL_IMPROVEMENT: { value: 'Continual Improvements' },
};

export const CLEANING_EVENT_CATEGORY = [
  BASE_EVENT_CATEGORY.NEWS.value,
  BASE_EVENT_CATEGORY.CRIME.value,
  BASE_EVENT_CATEGORY.NATURAL_DISASTER.value,
  BASE_EVENT_CATEGORY.PUBLIC_HEALTH_HAZARD.value,
  BASE_EVENT_CATEGORY.SOCIAL_POLITICAL.value,
  BASE_EVENT_CATEGORY.SITE_INCIDENT.value,
  BASE_EVENT_CATEGORY.CLEANING_TASK_INCIDENT.value,
  BASE_EVENT_CATEGORY.ASSET_INCIDENT.value,
  BASE_EVENT_CATEGORY.TRAVEL_INCIDENT.value,
  BASE_EVENT_CATEGORY.CUSTOMER_INCIDENT.value,
  BASE_EVENT_CATEGORY.OCCUPATIONAL_INCIDENT.value,
  BASE_EVENT_CATEGORY.OTHERS.value,
  BASE_EVENT_CATEGORY.CONTINUAL_IMPROVEMENT.value,
];

export const SECURITY_EVENT_CATEGORY = [
  BASE_EVENT_CATEGORY.NEWS.value,
  BASE_EVENT_CATEGORY.CRIME.value,
  BASE_EVENT_CATEGORY.NATURAL_DISASTER.value,
  BASE_EVENT_CATEGORY.PUBLIC_HEALTH_HAZARD.value,
  BASE_EVENT_CATEGORY.SOCIAL_POLITICAL.value,
  BASE_EVENT_CATEGORY.CONFLICT.value,
  BASE_EVENT_CATEGORY.SITE_INCIDENT.value,
  BASE_EVENT_CATEGORY.MAINTENANCE_TASK_INCIDENT.value,
  BASE_EVENT_CATEGORY.TRAVEL_INCIDENT.value,
  BASE_EVENT_CATEGORY.CUSTOMER_INCIDENT.value,
  BASE_EVENT_CATEGORY.TRIP_INCIDENT.value,
  BASE_EVENT_CATEGORY.ASSET_INCIDENT.value,
  BASE_EVENT_CATEGORY.OCCUPATIONAL_INCIDENT.value,
  BASE_EVENT_CATEGORY.SECURITY_EMERGENCY.value,
  BASE_EVENT_CATEGORY.SECURITY_ASSET.value,
  BASE_EVENT_CATEGORY.SECURITY_TRANSPORT.value, //deprecated
  BASE_EVENT_CATEGORY.SECURITY_PATROL.value,
  BASE_EVENT_CATEGORY.SECURITY_SITE.value, // deprecated
  BASE_EVENT_CATEGORY.OTHERS.value,
  BASE_EVENT_CATEGORY.CONTINUAL_IMPROVEMENT.value,
];

export const TRANSPORT_EVENT_CATEGORY = [
  BASE_EVENT_CATEGORY.NEWS.value,
  BASE_EVENT_CATEGORY.CRIME.value,
  BASE_EVENT_CATEGORY.NATURAL_DISASTER.value,
  BASE_EVENT_CATEGORY.SOCIAL_POLITICAL.value,
  BASE_EVENT_CATEGORY.CONFLICT.value,
  BASE_EVENT_CATEGORY.PUBLIC_HEALTH_HAZARD.value,
  BASE_EVENT_CATEGORY.ASSET_INCIDENT.value,
  BASE_EVENT_CATEGORY.TRAVEL_INCIDENT.value,
  BASE_EVENT_CATEGORY.TRIP_INCIDENT.value,
  BASE_EVENT_CATEGORY.OTHERS.value,
  BASE_EVENT_CATEGORY.SECURITY_TRANSPORT.value,
];
